// extracted by mini-css-extract-plugin
module.exports = {"video":"YouTubeBackground_video__fHFrW","fitContain":"YouTubeBackground_fitContain__2Qv3_"};